import { Components, Theme } from "@mui/material";
import { alertClasses } from "@mui/material/Alert";

export const ALERT_THEME: Components<Theme>["MuiAlert"] = {
  styleOverrides: {
    standard: ({ theme }: { theme: Theme }) => ({
      flex: 1,
      fontSize: theme.typography.pxToRem(16),
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
      paddingLeft: theme.spacing(16),
      paddingRight: theme.spacing(16),
      borderStyle: "solid",
      borderWidth: "2px",
      borderRadius: theme.spacing(8),
      color: theme.palette.text.primary,
      boxSizing: "border-box",
      [`& .${alertClasses.icon}`]: {
        color: theme.palette.text.primary,
        marginRight: theme.spacing(18),
        paddingTop: theme.spacing(12),
        paddingBottom: theme.spacing(12),
      },
      [`& .${alertClasses.action}`]: {
        flexShrink: 0,
        paddingTop: 0,
      },
      [`& .${alertClasses.message}`]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        overflow: "visible",
        paddingTop: theme.spacing(12),
        paddingBottom: theme.spacing(12),
      },
    }),
    standardError: ({ theme }: { theme: Theme }) => ({
      backgroundColor: theme.palette.error[100],
      borderColor: theme.palette.error[300],
    }),
    standardWarning: ({ theme }: { theme: Theme }) => ({
      backgroundColor: theme.palette.warning[100],
      borderColor: theme.palette.warning[300],
    }),
    standardInfo: ({ theme }: { theme: Theme }) => ({
      backgroundColor: theme.palette.info[100],
      borderColor: theme.palette.info[300],
    }),
    standardSuccess: ({ theme }: { theme: Theme }) => ({
      backgroundColor: theme.palette.success[100],
      borderColor: theme.palette.success[300],
    }),
  },
};

export const ALERT_TITLE_THEME: Components<Theme>["MuiAlertTitle"] = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      fontSize: theme.typography.pxToRem(16),
    }),
  },
};
